module.exports = __webpack_public_path__ + "img/footer-img1.b6ae24a0.jpg";